import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { media } from 'components/utils/breakpoints'

export const StepsList = styled(Box)`
    position: sticky;
    top: 0;
    list-style: none;
    display: flex;
    min-height: 64px;
    padding: var(--chakra-space-6) var(--chakra-space-8);
    margin-bottom: var(--chakra-space-8);
    font-weight: var(--chakra-fontWeights-medium);
    z-index: 1000;
    background: var(--chakra-colors-info-500);

    li {
        --divider: currentColor;
        display: flex;
        align-items: center;
        flex: none;
        color: var(--chakra-colors-lime-500);
        font-size: 12px;

        &:not(:last-of-type)::after {
            content: '';
            max-width: 30px;
            min-width: 20px;
            height: 2px;
            background-color: var(--chakra-ring-offset-color);
            margin-inline: var(--chakra-space-4);
        }

        &[aria-disabled='true'] {
            color: var(--chakra-ring-offset-color);
        }
    }

    span {
        color: inherit;
    }

    @media ${media('md', 'max')} {
    }
`
